import React from "react";
import TermsAndPrivacyPanel from "container/termsAndPrivacy/TermsAndPrivacyPanel";
import PropTypes from "prop-types";

RootPrivacy.propTypes = {
  language: PropTypes.string
};

function RootPrivacy(props) {
  const { language } = props;

  return <TermsAndPrivacyPanel language={language} type={"privacy"} />;
}

export default RootPrivacy;
